'use client'

import { usePathname } from 'next/navigation'
import type { ReactNode } from 'react'

/**
 * Conditionally renders the player nav/header + footer. They are HIDDEN on the
 * sign-in surface (`/play/auth*`) — an unauthenticated login page must not show
 * the learner nav bar (Home / Play / Library / …). Everywhere else inside the
 * player portal the full chrome renders normally.
 */
export function PlayerChrome({
  header,
  footer,
  children,
}: {
  header: ReactNode
  footer: ReactNode
  children: ReactNode
}) {
  const pathname = usePathname() || ''
  const bare = pathname.startsWith('/play/auth')

  if (bare) {
    // Login surface — center the card in the viewport, no nav, no footer.
    return <main className="flex-1 flex flex-col">{children}</main>
  }

  return (
    <>
      {header}
      <main className="flex-1">{children}</main>
      {footer}
    </>
  )
}
